import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'sws-infofooter',
  templateUrl: './infofooter.component.html',
  styleUrls: ['./infofooter.component.scss']
})
export class InfofooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// D:/Crossplatform/swsLagerinfo/src/app/infofooter/infofooter.component.ts